module.exports = __webpack_public_path__ + "static/nanda-6dc90499ba171316e188d141e5510bbe.jpg";